import { format } from 'date-fns'
import {
  DocumentSigningTemplateBlock,
  DocumentSigningTemplateBlockType,
  SignedBlockContent,
} from '../../../lib/db/db.types'

export const blockTypeToLabel: Record<
  DocumentSigningTemplateBlockType,
  string
> = {
  [DocumentSigningTemplateBlockType.SIGNATURE]: 'Signature',
  [DocumentSigningTemplateBlockType.DATE_SIGNED]: 'Date signed',
  [DocumentSigningTemplateBlockType.DATE_SIGNED_BOXES]: 'Date signed (boxes)',
  [DocumentSigningTemplateBlockType.NAME]: 'Full name',
}

export const getSigningDateText = (date: Date) => {
  return format(date, 'dd MMM yyyy')
}

export const getSignedBlockValue = (
  block: DocumentSigningTemplateBlock,
  {
    currentDate,
    signatureName,
    signatureImage,
  }: { currentDate: Date; signatureName?: string; signatureImage?: string },
): SignedBlockContent => {
  switch (block.type) {
    case DocumentSigningTemplateBlockType.SIGNATURE:
      if (!signatureImage) {
        throw new Error('Signature image not set')
      }
      return { type: 'image', imageSrc: signatureImage }

    case DocumentSigningTemplateBlockType.DATE_SIGNED:
      return { type: 'text', text: getSigningDateText(currentDate) }

    case DocumentSigningTemplateBlockType.DATE_SIGNED_BOXES:
      return {
        type: 'date-boxes',
        date: currentDate.toISOString().split('T')[0],
      }

    case DocumentSigningTemplateBlockType.NAME:
      if (!signatureName) {
        throw new Error('Signature name not set')
      }
      return { type: 'text', text: signatureName }
  }
}

export const getDateSignedBoxSizings = ({
  width,
  height,
}: {
  width: number
  height: number
}) => {
  const boxHeight = Math.floor(height * 0.9) // slightly smaller than container, to fit nicely inside boxes

  const numBoxes = 8
  const numSpacesBetweenSections = 2
  const numSpacesBetweenBoxes = 5

  const totalSpacingUnits =
    numBoxes * 32 + numSpacesBetweenSections * 16 + numSpacesBetweenBoxes

  // Round down to nearest 0.5 pixel for consistent rendering
  const unitWidth = Math.floor((width / totalSpacingUnits) * 16) / 16

  const boxWidth = unitWidth * 32
  const sectionSpacingWidth = unitWidth * 16
  const boxSpacingWidth = unitWidth

  return {
    boxHeight,
    boxWidth,
    sectionSpacingWidth,
    boxSpacingWidth,
  }
}
